import fvSubassembly from "../fvSubassembly"
export default class fvChipObj extends fvSubassembly{
    constructor(sContent,parent,system,callback){
        super(sContent,parent,system);
        this.create();
        if(this.isDelayedWaiting){
            this.complete = callback;
        }else{
            callback(this);
        }
        if(this.endRadian == "3.1"){
            this.endRadian = this.endRadian + "415926";
        }
        if(this.startRadian == "3.1"){
            this.startRadian = this.startRadian + "415926";
        }
        if(this.startRadian == "-3.1"){
            this.startRadian = this.startRadian + "415926";
        }
        if(this.endRadian == "-3.1"){
            this.endRadian = this.endRadian + "415926";
        }
        
        this.endRadianVal = Number(this.endRadian);
        this.startRadian = Number(this.startRadian);
        // 开始角和结束角相等（圆 = 2*Math.PI）
        if(this.startRadian == this.endRadian){
          this.endRadianVal = -(this.startRadian + 2*Math.PI)
          if(this.endRadianVal <0){
            this.endRadianVal = this.endRadianVal*2;  
          }
        }
        this.moveWidth = this.borderWidth/2;
        this.createSucss();
        this.isHide = true;
        if(this.animation.fvHide){
            this.isHide = false;
        }
    }

    onDraw(canvas){
        this.setCanvas(canvas)
        if(!this.isHide) return;
        if(!this.fcHide) return;
        this.formatRect();
        this.executePreAnimation(canvas);
        canvas.save();
        if(parseFloat(this.width) > parseFloat(this.height)){
            this.scaleX = 1;
            this.scaleY = parseFloat(this.height)/parseFloat(this.width);
            this.radius = parseFloat(this.width)/2;
        }else{
            this.scaleY = 1;
            this.scaleX = parseFloat(this.width)/parseFloat(this.height);
            this.radius = parseFloat(this.height)/2;
        }
        this.centerX = (this.cx + parseFloat(this.width)/2)/this.scaleX;
        this.centerY = (this.cy + parseFloat(this.height)/2)/this.scaleY;
        if(this.borderWidth == 1){
            canvas.setLineDash(this.lineStyle(this.lineType));
        }
        canvas.beginPath();
        // canvas.fillStyle = this.color;
        if(this.color=="" || this.opacity<=0){
            canvas.fillStyle = "rgba(255, 255, 255, 0)";//矩形填充透明
        }else{
            var rgbArray = this.color.colorRgb(this.opacity/255);;
            canvas.fillStyle = this.color;//矩形填充颜色
        }
		//设置线宽度
		if(this.borderWidth == 0){
		    canvas.lineWidth = 0.01;
		}else{
		    canvas.lineWidth = this.borderWidth;
		}
        canvas.strokeStyle = this.borderColor;
        // canvas.fillStyle = "#EFC93C";//矩形填充颜色
        // canvas.fillRect(0,0,this.width,this.height);//矩形坐标及大小
        
        if(this.renderType > 0){
            canvas.scale(this.scaleX, this.scaleY);
            canvas.arc(this.centerX+this.borderWidth/2,this.centerY+this.borderWidth/2,this.radius,this.startRadian,this.endRadianVal,true);
            canvas.fill();
            canvas.clip();
        }else{
            canvas.scale(this.scaleX, this.scaleY);
            canvas.arc(this.centerX-this.borderWidth,this.centerY-this.borderWidth,this.radius,this.startRadian,this.endRadianVal,true);
            canvas.closePath();
            if(this.color && this.renderType == 0){
                // if(this.opacity > 0){
                //     var rgbArray = this.color.colorRgb(this.opacity/255);
                //     this.color = rgbArray ;
                // }else{
                //     // var rgbArray1 = this.color.colorRgb(0.0001);
                //     this.color = rgbArray1;
                // }
                canvas.fill();
            }
            canvas.stroke();
        }
        // 切不设置风格
        // this.Render();
        canvas.restore();
        this.executePosAnimation(canvas);
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvChipObj.js